import {endpoints, requestTypes, services} from "./config";
import { loadingOff, loadingOn} from "../actions";

export const loginOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.auth,
    method:requestTypes.POST,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getVehicleOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.vehicle,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getUsersOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.users,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const deleteUserOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.users,
    method:requestTypes.DELETE,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const postUserOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.users,
    method:requestTypes.POST,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getUserProfileDriverOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.userProfileDriver,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getAllExperiencesOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.allExperiences,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getExperienceOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.experience,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const postExperienceOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.experience,
    method:requestTypes.POST,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const deleteExperienceOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.experience,
    method:requestTypes.DELETE,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getComponentGroupOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.componentGroup,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const postComponentGroupOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.componentGroup,
    method:requestTypes.POST,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const deleteComponentGroupOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.componentGroup,
    method:requestTypes.DELETE,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getClaimedOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.claimed,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const postClaimedOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.claimed,
    method:requestTypes.POST,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const deleteClaimedOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.claimed,
    method:requestTypes.DELETE,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getDataUsedClaimedOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.usedClaimed,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getAnomalyOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.anomaly,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const postAnomalyOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.anomaly,
    method:requestTypes.POST,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const deleteAnomalyOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.anomaly,
    method:requestTypes.DELETE,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getDataTesisAnomalyOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.tesisAnomaly,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getDataItemsTesisOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.tesisItem,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getDataTesisGroupsOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.tesisGroup,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};

export const getDataTesisSubroupsOptions = {
    protocolRequest:endpoints.apiProtocol,
    host: endpoints.apiEndpoint,
    path: services.tesisSubgroup,
    method:requestTypes.GET,
    showLoading: loadingOn,
    hideLoading: loadingOff
};


// WEBPACK FOOTER //
// ./src/util/optionsRequest.js